// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Artboard 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/info.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 25px;
    width: 26px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
}

.add-icon-disabled {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 25px;
    width: 26px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
    cursor: not-allowed;
}

.actionKpiTable .react-bootstrap-table {
    height: 25rem !important;
}

.actionKpiContainer .react-confirm-alert-body {
    padding: 1rem;
}

.actionKpiContainer .react-confirm-alert-body>h1 {
    background-color: transparent !important;
    background-color: initial !important;
    color: #e50000 !important;
}

.saveConfirmBox {
    padding: 1rem;
    background-color: #FFFFFF;
    border-radius: 20px;
    width: 30rem;
    font-family: "Arial", sans-serif;
    font-size: 0.81rem;
}

.saveConfirmBox .modal-footer {
    padding: 0px;
}

.titleClass-toyota {
    color: #e50000;
}

.titleClass-lexus {
    color: #252525;
}

.activityKpiTable tbody, .activityKpiTable tr {
    display: block;
}

.activityKpiTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.activityKpiTable tbody {
    /*   max-height:45vh;
    overflow-y: auto;  */
    margin-top: 14px;
}

.activityKpiTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.activityKpiTable tbody>tr>td {
    width: 7rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.activityKpiTable thead>tr>th {
    text-overflow: ellipsis;
    overflow: hidden;
}

.activityKpiTable thead>tr>th {
    width: 7rem;
    float: left;
}

/* .activityKpiTable tbody tr td{
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
} */

.activityKpiTable thead tr {
    padding-left: 10px;
}

.toyota-icon {
    color: #e50000;
    cursor: pointer;
}

.lexus-icon {
    color: #424242;
    cursor: pointer;
}

.react-bootstrap-table-editing-cell {
    padding-top: 5px!important;
    padding-bottom: 2px!important;
}

.react-bootstrap-table-editing-cell>input {
    padding-top: 3px!important;
    padding-bottom: 3px!important;
    height: 30px;
}

.activitytargetTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
    float: left;
    width: auto !important;
}

.activitytargetTable {
    max-width: 29%;
    float: left;
    margin-left: -20px;
    overflow-x: auto;
}

.activitytargetTable .react-bs-table-container {
    width: 99% !important;
}

.activityinitialTable {
    max-width: 70%;
    overflow-x: auto;
    float: left;
}

.activityinitialTable tbody>tr>td {
    height: 40px !important;
    padding-top: 10px !important;
}

.activitytargetTable tbody, .activitytargetTable tr {
    display: block;
}

.activitytargetTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.activitytargetTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.activitytargetTable tbody>tr>td {
    width: 6.6rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: "nowrap";
    text-align: center !important;
    padding-top: 10px !important;
    height: 40px !important;
}

.activityinitialTable tbody>tr>td:nth-child(4), .activityinitialTable tbody>tr>td:nth-child(5) {
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: "nowrap";
    text-align: center !important;
    padding-top: 10px !important;
    height: 40px !important;
}

.activityinitialTable thead>tr>th:nth-child(4), .activityinitialTable thead>tr>th:nth-child(5) {
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: "nowrap";
    text-align: center !important;
}

.activitytargetTable thead>tr>th {
    width: 6.6rem;
    float: left;
    margin-top: -0.5rem;
    padding-left: 0.1rem;
}

.activitytargetTable tbody tr td {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
}

.activitytargetTable thead tr {
    display: flex;
}

.activitytargetTable .form-control, .activityinitialTable .form-control {
    height: 38px;
    background-color: white;
    text-align: center;
    margin-top: -9px;
    margin-left: 5px;
    padding: 0px;
}

.activitytargetTable tbody {
    /*   background:rgba(212, 210, 210, 0);  */
    /*  max-height:45vh;
    overflow-y: auto;  */
}

.activitytargetTable tbody tr {
    
    display: flex;
}

.targetClass {
    max-width: 64.375rem !important;
}

.actionPlanTableModal tbody {
    border: solid 1px #a8aaac;
    max-height: 45vh;
    overflow-y: scroll !important;
}

.actionPlanTableModal tbody, .actionPlanTableModal tr {
    display: block;
}

.actionPlanTableModal tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.actionPlanTableModal table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.actionPlanTableModal tbody>tr>td {
    float: left;
    overflow: hidden;
    max-height: 3rem;
}

.actionPlanTableModal thead>tr>th {
    float: left;
}

.actionPlanTableModal tbody tr td {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
}

.actionPlanTableModal thead tr {
    padding-left: 10px;
}

.mainContainer {
    max-width: 1500px;
}

.editableColumn {
    /* box-shadow: 0 0 5px rgb(12, 124, 216); */
    padding: 3px 0px 3px 3px;
    margin: 5px 1px 3px 0px;
    border: 1px solid rgb(12, 124, 216);
    background-color: white !important;
    /* width: 7.2rem !important; */
}

.activityKpiModal .form-control {
    height: 30px;
}

#addActionActivityModal .react-bootstrap-table-editing-cell input {
    width: 100px !important;
}

/* .activityinitialTable .react-bootstrap-table-editing-cell input {
    width: 115px !important;
} */

.activityinitialTable .react-bootstrap-table-editing-cell {
    width: 17% !important;
}

.addActionActivityModal-toyota .modal-dialog, .addActionActivityModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.addActionActivityModal-lexus .modal-dialog, .addActionActivityModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.addActionActivityModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.addActionActivityModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.info-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}`, "",{"version":3,"sources":["webpack://./src/components/actionKpiTable/index.css"],"names":[],"mappings":"AAAA;IACI,yDAA2D;IAC3D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yDAA2D;IAC3D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAoC;IAApC,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;wBACoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;;;;GAIG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C;wBACoB;AACxB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,wBAAwB;IACxB,uBAAuB;IACvB,mCAAmC;IACnC,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB","sourcesContent":[".add-icon {\n    background-image: url(\"../../assets/images/Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n}\n\n.add-icon-disabled {\n    background-image: url(\"../../assets/images/Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n    cursor: not-allowed;\n}\n\n.actionKpiTable .react-bootstrap-table {\n    height: 25rem !important;\n}\n\n.actionKpiContainer .react-confirm-alert-body {\n    padding: 1rem;\n}\n\n.actionKpiContainer .react-confirm-alert-body>h1 {\n    background-color: initial !important;\n    color: #e50000 !important;\n}\n\n.saveConfirmBox {\n    padding: 1rem;\n    background-color: #FFFFFF;\n    border-radius: 20px;\n    width: 30rem;\n    font-family: \"Arial\", sans-serif;\n    font-size: 0.81rem;\n}\n\n.saveConfirmBox .modal-footer {\n    padding: 0px;\n}\n\n.titleClass-toyota {\n    color: #e50000;\n}\n\n.titleClass-lexus {\n    color: #252525;\n}\n\n.activityKpiTable tbody, .activityKpiTable tr {\n    display: block;\n}\n\n.activityKpiTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.activityKpiTable tbody {\n    /*   max-height:45vh;\n    overflow-y: auto;  */\n    margin-top: 14px;\n}\n\n.activityKpiTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.activityKpiTable tbody>tr>td {\n    width: 7rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.activityKpiTable thead>tr>th {\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.activityKpiTable thead>tr>th {\n    width: 7rem;\n    float: left;\n}\n\n/* .activityKpiTable tbody tr td{\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n} */\n\n.activityKpiTable thead tr {\n    padding-left: 10px;\n}\n\n.toyota-icon {\n    color: #e50000;\n    cursor: pointer;\n}\n\n.lexus-icon {\n    color: #424242;\n    cursor: pointer;\n}\n\n.react-bootstrap-table-editing-cell {\n    padding-top: 5px!important;\n    padding-bottom: 2px!important;\n}\n\n.react-bootstrap-table-editing-cell>input {\n    padding-top: 3px!important;\n    padding-bottom: 3px!important;\n    height: 30px;\n}\n\n.activitytargetTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n    float: left;\n    width: auto !important;\n}\n\n.activitytargetTable {\n    max-width: 29%;\n    float: left;\n    margin-left: -20px;\n    overflow-x: auto;\n}\n\n.activitytargetTable .react-bs-table-container {\n    width: 99% !important;\n}\n\n.activityinitialTable {\n    max-width: 70%;\n    overflow-x: auto;\n    float: left;\n}\n\n.activityinitialTable tbody>tr>td {\n    height: 40px !important;\n    padding-top: 10px !important;\n}\n\n.activitytargetTable tbody, .activitytargetTable tr {\n    display: block;\n}\n\n.activitytargetTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.activitytargetTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.activitytargetTable tbody>tr>td {\n    width: 6.6rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: \"nowrap\";\n    text-align: center !important;\n    padding-top: 10px !important;\n    height: 40px !important;\n}\n\n.activityinitialTable tbody>tr>td:nth-child(4), .activityinitialTable tbody>tr>td:nth-child(5) {\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: \"nowrap\";\n    text-align: center !important;\n    padding-top: 10px !important;\n    height: 40px !important;\n}\n\n.activityinitialTable thead>tr>th:nth-child(4), .activityinitialTable thead>tr>th:nth-child(5) {\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: \"nowrap\";\n    text-align: center !important;\n}\n\n.activitytargetTable thead>tr>th {\n    width: 6.6rem;\n    float: left;\n    margin-top: -0.5rem;\n    padding-left: 0.1rem;\n}\n\n.activitytargetTable tbody tr td {\n    padding-top: 0px;\n    padding-bottom: 0px;\n    padding-left: 0px;\n}\n\n.activitytargetTable thead tr {\n    display: flex;\n}\n\n.activitytargetTable .form-control, .activityinitialTable .form-control {\n    height: 38px;\n    background-color: white;\n    text-align: center;\n    margin-top: -9px;\n    margin-left: 5px;\n    padding: 0px;\n}\n\n.activitytargetTable tbody {\n    /*   background:rgba(212, 210, 210, 0);  */\n    /*  max-height:45vh;\n    overflow-y: auto;  */\n}\n\n.activitytargetTable tbody tr {\n    \n    display: flex;\n}\n\n.targetClass {\n    max-width: 64.375rem !important;\n}\n\n.actionPlanTableModal tbody {\n    border: solid 1px #a8aaac;\n    max-height: 45vh;\n    overflow-y: scroll !important;\n}\n\n.actionPlanTableModal tbody, .actionPlanTableModal tr {\n    display: block;\n}\n\n.actionPlanTableModal tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.actionPlanTableModal table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.actionPlanTableModal tbody>tr>td {\n    float: left;\n    overflow: hidden;\n    max-height: 3rem;\n}\n\n.actionPlanTableModal thead>tr>th {\n    float: left;\n}\n\n.actionPlanTableModal tbody tr td {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n}\n\n.actionPlanTableModal thead tr {\n    padding-left: 10px;\n}\n\n.mainContainer {\n    max-width: 1500px;\n}\n\n.editableColumn {\n    /* box-shadow: 0 0 5px rgb(12, 124, 216); */\n    padding: 3px 0px 3px 3px;\n    margin: 5px 1px 3px 0px;\n    border: 1px solid rgb(12, 124, 216);\n    background-color: white !important;\n    /* width: 7.2rem !important; */\n}\n\n.activityKpiModal .form-control {\n    height: 30px;\n}\n\n#addActionActivityModal .react-bootstrap-table-editing-cell input {\n    width: 100px !important;\n}\n\n/* .activityinitialTable .react-bootstrap-table-editing-cell input {\n    width: 115px !important;\n} */\n\n.activityinitialTable .react-bootstrap-table-editing-cell {\n    width: 17% !important;\n}\n\n.addActionActivityModal-toyota .modal-dialog, .addActionActivityModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.addActionActivityModal-lexus .modal-dialog, .addActionActivityModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.addActionActivityModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.addActionActivityModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.info-icon {\n    background-image: url(\"../../assets/images/info.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
